export default "__VITE_ASSET__DtodwEoC__"